import React, { Component } from 'react';
import { Flex } from 'core/components';
import { observer } from 'mobx-react';
import { createToolResultComponent } from './ToolResultFactory';

/**
 * Renders a <Card> that when clicked, opens the side Modal with the
 * query the tool returned.
 */

@observer
class KaizenToolResultPanel extends Component {
  scrollRef = React.createRef();

  componentDidUpdate(prevProps) {
    const { tools } = this.props;
    if (tools && prevProps.tools && tools.length !== prevProps.tools.length) {
      const node = this.scrollRef.current;
      if (node) {
        node.scrollTo({ top: node.scrollHeight, behavior: 'smooth' });
      }
    }
  }

  render() {
    const { tools, onCloseToolResult, onDataViewCreate, onQueryError } = this.props;

    if (!tools || tools.length === 0) {
      return null;
    }

    const chartHeight = 500;

    return (
      <Flex className="tool-result-panel" flexDirection="column" height="100%" borderLeft="thin">
        <Flex flexDirection="column" height="100%" flex={1} p="12px" gap="12px" overflow="auto" ref={this.scrollRef}>
          {tools.map((tool) =>
            createToolResultComponent(tool, {
              onCloseToolResult,
              onDataViewCreate,
              onQueryError,
              chartHeight
            })
          )}
        </Flex>
      </Flex>
    );
  }
}

export default KaizenToolResultPanel;
